// extracted by mini-css-extract-plugin
export default {"-large":"B_U1AHHAaahJ6wbItryv","addAudioButton":"hTGkIpzdI4AJfv3Xfhvi","content":"qJL7t8B5QmWB3aWiDLpp"};